import { FormControlLabel } from '@mui/material';
import { IOSSwitch } from './IOSSwitch';

export default function BotaoToggle(props) {
  return (
    <FormControlLabel
      {...props}
      control={
        <IOSSwitch checked={props.value} />
      }
    />
  )
}
